export const CHANGE_CURRENT_PAGE = 'sendgridSettings/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'sendgridSettings/CHANGE_PAGE_SIZE'
export const CREATE_SENDGRID_SETTING = 'sendgridSettings/CREATE_SENDGRID_SETTING'
export const FETCH_SENDGRID_SETTINGS_LIST = 'sendgridSettings/FETCH_SENDGRID_SETTINGS_LIST'
export const FETCH_SENDGRID_SETTINGS_FOR_OPTIONS = 'sendgridSettings/FETCH_SENDGRID_SETTINGS_FOR_OPTIONS'
export const REMOVE_SENDGRID_SETTING = 'sendgridSettings/REMOVE_SENDGRID_SETTING'
export const UPDATE_SENDGRID_SETTING = 'sendgridSettings/UPDATE_SENDGRID_SETTING'
